import { ActionCallback, apiBase } from '../api';
import { AdminTickerInfo, ChangeTickersStatusType, ClipDataOut, ExchangeInfoOut, ExpirationTime, FixFieldType, FixValueType, GetPartnerRefsOut, KSettings, LogEntry, PartnerPayout, PartnerPayoutsOut, PartnerPayoutType, PartnerRef, Promo, PromoCampaign, SearchTickersOut, ServerAction, ServerInfo, ServerNode, ServersInfo, SmcSetting, SmcSettingField, TextTemplate, TickerSmcType, TickersOut, TickersStatusOut, UpdateTickerIn, UpdateUserIn, User, UserExpType, UserPaymentsOut, UsersOut, UserTickersOut } from '../config/admin';
import { UserPlan, UserSubscription } from '../config/plans';
import { ExchangeType, TickerAssetType, TimeFrame } from '../config/tickers';
import { TVContext } from '../hub/context';

export class adminApi extends apiBase {

    static startTickerCross = Date.UTC(2000, 0, 1);
    public static errorHandler: ActionCallback<string>;

    public static post<TOut>(n: string, i: any = null, host: string = null) {
        return new Promise<TOut>((res: ActionCallback<TOut>, rej: ActionCallback<string>) => {
            apiBase.postData<TOut>('admin/' + n, (r) => {
                if (r.error != null) {
                    if (adminApi.errorHandler)
                        adminApi.errorHandler(r.error);
                    rej(r.error);
                } else {
                    res(r.d);
                }
            }, i, host);
        });
    }
    public static getDevSet = (host: string, un: string, pn: string) => adminApi.post<string>("getDevSet", {
        un: un,
        pn: pn
    }, host);
    public static setDevSet = (host: string, un: string, pn: string, set: string) => adminApi.post<string>("setDevSet", {
        un: un,
        pn: pn,
        set: set
    }, host);
    public static getTemplates = () => adminApi.post<TextTemplate[]>("getTemplates");
    public static updateTemplates = (deleted: number[], updated: TextTemplate[]) => adminApi.post<number[]>("updateTemplates", {
        deleted: deleted,
        updated: updated
    });
    public static testTemplate = (template: TextTemplate, addr?: string) => adminApi.post<void>("testTemplate", {
        template: template,
        addr: addr
    });

    public static getTimeFrames() {
        return adminApi.post<TimeFrame[]>("getTimeFrames");
    }
    public static getSmcSettings(field: SmcSettingField) {
        return adminApi.post<SmcSetting[]>("getSmcSettings", field);
    }

    public static updateSmcSettings(deleted: number[], updated: SmcSetting[]) {
        return adminApi.post<number[]>("updateSmcSettings", {
            deleted: deleted,
            updated: updated
        });
    }
    public static getKSettings(tid: string, tf: number) {
        return adminApi.post<KSettings>("getKSettings", {
            tid: tid,
            tf: tf
        });
    }

    public static searchNewTickers(host: string, userInput: string, asset: TickerAssetType, exchId: ExchangeType, download: boolean = false, ignoreList: string[]) {
        return adminApi.post<SearchTickersOut>("searchNewTickers", {
            userInput: userInput,
            asset: asset,
            exchId: exchId,
            download: download,
            ignoreList: ignoreList
        }, host);
    }

    public static getLogs(host: string) {
        return adminApi.post<LogEntry[]>("getLogs", null, host);
    }
    public static getExchanges() {
        return adminApi.post<ExchangeInfoOut>("getExchanges");
    }

    public static getTickersStatus = (host: string, tids: string[]) =>
        adminApi.post<TickersStatusOut>('getTickersStatus', tids, host);

    public static getTickers = (userInput: string, asset: TickerAssetType, exchId: ExchangeType, serverId: number) =>
        adminApi.searchTickers(userInput, 0, 100, asset, exchId, serverId, TickerSmcType.Any);

    public static searchTickers(userInput: string, index: number, size: number, asset: TickerAssetType, exchId: ExchangeType, serverId: number, smc: TickerSmcType) {
        return adminApi.post<TickersOut>("searchTickers", {
            userInput: userInput,
            page: index,
            pageSize: size,
            asset: asset,
            exchId: exchId,
            smc: smc,
            serverId: serverId
        });
    }

    public static addTicker(ticker: AdminTickerInfo) {
        return adminApi.post<void>("addTicker", ticker);
    }

    public static updateTicker = (ticker: UpdateTickerIn) =>
        adminApi.post<void>("updateTicker", ticker);

    public static removeTicker(tid: string) {
        return adminApi.post<void>("removeTicker", tid);
    }

    public static changeTickersStatusByType(host: string, type: ChangeTickersStatusType, scan: boolean) {
        return adminApi.post<TickersOut>("changeTickersStatusByType", {
            type: type,
            scan: scan
        }, host);
    }
    public static changeTickersStatus(host: string, tids: string[], scan: boolean) {
        return adminApi.post<TickersOut>("changeTickersStatus", {
            tids: tids,
            scan: scan
        }, host);
    }

    public static eraseTickersData(host: string, tids: string[]) {
        return adminApi.post<void>("eraseTickersData", tids, host);
    }

    public static cleanTickersSmpa(host: string, tids: string[]) {
        return adminApi.post<void>("cleanTickersSmpa", tids, host);
    }
    public static executeServerAction(id: number, action: ServerAction, host: string) {
        return adminApi.post<string>("executeServerAction", { id: id, action: action }, host);
    }
    public static getServerInfo(host: string) {
        return adminApi.post<ServerInfo>("getServerInfo", null, host);
    }
    public static pingSMPA(bar: number, tvd: TVContext) {
        return adminApi.post<string>("pingSMPA", { tid: tvd.tid, at: bar }, tvd.getTickerInfo().feed);
    }
    public static clearCachedBars(tvd: TVContext) {
        return adminApi.post<void>("clearCachedBars", tvd.tid);
    }

    public static barReplay(tid: string, tf: string, at: number, skip: number, pingSmc: boolean) {
        return adminApi.post<ClipDataOut>("barReplay", {
            tid: tid,
            tf: tf,
            at: at,
            skip: skip,
            pingSmc: pingSmc
        });
    }

    public static getUserSubscriptions(uid: number) {
        return adminApi.post<UserSubscription[]>("getUserSubscriptions", uid);
    }
    public static updateUserSubscriptions(deleted: number[], updated: UserSubscription[]) {
        return adminApi.post<number[]>("updateUserSubscriptions", {
            deleted: deleted,
            updated: updated
        });
    }
    public static updateUserPlan(plan: UserPlan) {
        return adminApi.post<void>("updateUserPlan", plan);
    }
    public static deleteUserPlan(planId: number) {
        return adminApi.post<void>("deleteUserPlan", planId);
    }
    public static getUserPlans(userId: number) {
        return adminApi.post<UserPlan[]>("getUserPlans", userId);
    }
    public static getUser = (id: number) => adminApi.post<User>("getUser", id);

    public static searchUsers(userInput: string, page: number, pageSize: number, partnerId: number = null, onlyPartners: boolean = false, planIds: number[] = null, activeOnly = false) {
        return adminApi.post<UsersOut>("searchUsers", {
            userInput: userInput == null ? '' : userInput,
            page: page,
            pageSize: pageSize,
            partnerId: partnerId,
            onlyPartners: onlyPartners ?? false,
            planIds: planIds,
            activeOnly: activeOnly
        });
    }
    public static getPartnerPayouts = (page: number, pageSize: number, partnerId: number, type: PartnerPayoutType, history = false) =>
        adminApi.post<PartnerPayoutsOut>("getPartnerPayouts", {
            page: page,
            pageSize: pageSize,
            type: type,
            partnerId: partnerId,
            history: history
        });

    public static getPartnerPayoutBy = (partnerId: number, by: number) =>
        adminApi.post<number>("getPartnerPayoutBy", {
            partnerId: partnerId,
            by: by
        });

    public static savePartnerPayout = (input: PartnerPayout) =>
        adminApi.post<number>("savePartnerPayout", input);

    //public static payoutBy = (id: number) =>
    //    adminApi.post<void>("payoutBy", id);

    public static addUserPayment = (uId: number, ambWallet: boolean, amount: number) =>
        adminApi.post<void>("addUserPayment", {
            uId: uId,
            ambWallet: ambWallet,
            amount: amount
        });

    public static confirmUserPayment = (id: number, amount: number) =>
        adminApi.post<void>("confirmUserPayment", {
            id: id,
            amount: amount
        });


    public static getUserPayments(userInput: string, page: number, pageSize: number, uid: number, partnerId: number = null, onlyPaid: boolean = false, history = false) {
        return adminApi.post<UserPaymentsOut>("getUserPayments", {
            userInput: userInput,
            page: page,
            pageSize: pageSize,
            uid: uid,
            partnerId: partnerId,
            onlyPaid: onlyPaid,
            history: history
        });
    }
    public static getPartnerRefs = (id: number) =>
        adminApi.post<GetPartnerRefsOut>("getPartnerRefs", id);

    public static deletePartnerRef = (id: number) =>
        adminApi.post<number>("deletePartnerRef", id);

    public static setPartnerRefs(uid: number, codes: PartnerRef[], defaultConfig: string, defaultPlanId: number) {
        return adminApi.post<PartnerRef[]>("setPartnerRefs", {
            uId: uid,
            partnerRefs: codes,
            defaultConfig: defaultConfig,
            defaultPlanId: defaultPlanId
        });
    }

    public static updateUser(user: UpdateUserIn) {
        return adminApi.post<User>("updateUser", user);
    }
    public static resetUserChats(userId: number) {
        return adminApi.post<void>("resetUserChats", userId);
    }
    public static removeUser(userId: number) {
        return adminApi.post<void>("removeUser", userId);
    }
    public static setUserExpiration(userId: number, type: UserExpType, amount: number, tf: ExpirationTime) {
        return adminApi.post<number>("setUserExpiration", {
            id: userId,
            type: type,
            amount: amount,
            tf: tf
        });
    }

    public static addFormula(tid: string) {
        return adminApi.post<UserTickersOut>("addFormula", tid);
    }

    public static fixData(field: FixFieldType, at: number, condVal: number, valType: FixValueType, newVal: number, tvd: TVContext) {
        return adminApi.post<void>("fixData", {
            tid: tvd.tid,
            tf: tvd.tf,
            orig: at,
            field: field,
            condVal: condVal,
            newVal: newVal,
            valType: valType,
        });
    }

    public static getServers() {
        return adminApi.post<ServersInfo>("getServers");
    }
    public static updateServer(deleteId: number, update: ServerNode) {
        return adminApi.post<number>("updateServer", {
            deleteId: deleteId,
            update: update
        });
    }

    public static updatePromoCampaign = (deleted: number, updated: PromoCampaign) =>
        adminApi.post<number>("updatePromoCampaign", {
            deleted: deleted,
            updated: updated
        });

    public static getPromoCampaigns = (uid: number) =>
        adminApi.post<PromoCampaign[]>("getPromoCampaigns", uid);

    public static updatePromo = (deleted: number, updated: Promo) =>
        adminApi.post<number>("updatePromo", {
            deleted: deleted,
            updated: updated
        });

    public static getPromos = (uid: number) =>
        adminApi.post<Promo[]>("getPromos", uid);

    public static generatePromo = (camId: number) =>
        adminApi.post<string>("generatePromo", camId);

}

